module.exports = __webpack_public_path__ + "static/media/add_fact_first.4efd0733.png";